import Vue from "vue";
import VueRouter from "vue-router";
import { trainingRoute } from "./training";
import { panelRoute } from "./panel";
import { getToken, checkTokenExpiry, checkAdminAccess, clearCookies } from "@/utils/login/tokenCheck";
// import store from "@/store";

Vue.use(VueRouter);

export const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login/LoginPage.vue"),
  },
  {
    path: "/",
    name: "Layout",
    redirect: "/kanban",
    component: () => import("@/views/Layout.vue"),
    children: [...trainingRoute, ...panelRoute],
  },
];

const createRouter = () =>
  new VueRouter({
    mode: "history",
    scrollBehavior: () => ({ y: 0 }),
    routes,
  });

const router = createRouter();

export const resetRouter = () => {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
};

router.beforeEach(async (to, from, next) => {
  const hasToken = getToken();
  if (!hasToken && to.name == 'Login') {
    next()
  }
  else if (hasToken) {
    const expiryTime = checkTokenExpiry();
    if (expiryTime && checkAdminAccess(to.query.uuid)) {
      if (to.name == 'Login') next('/')
      else next()
    }
    else {
      if(to.name == 'PanelFeedback' && to.query.uuid){
        next(`/login?uuid=${to.query.uuid}&from=panel`);
    }
    else{
      localStorage.clear();
      clearCookies();
      next('/login');
    }
    }
  }
  else if(to.name == 'PanelFeedback' && to.query.uuid){
      next(`/login?uuid=${to.query.uuid}&from=panel`);
  }
  else {
    localStorage.clear();
    clearCookies();
    next('/login');
  }
});

export default router;
